import React from "react";
import { Link } from "react-router-dom";
import { parseHours } from "../../../helpers/time";
import "./Summary.css";

const Summary = ({ timesheet, closeHandler, sortedRows }) => {
  const totaledInvoices = timesheet.rates.reduce(
    (_acc, _rateElem, index) =>
      _rateElem.invoice
        ? _acc +
          _rateElem.invoice * timesheet.standardRateTotals[index].invoiceQty
        : _acc,
    0
  );
  return (
    <div className="timesheets__summary-tableWrapper">
      <div className="timesheets__summary">
        <h4 className="timesheets__summary-title tw-text-2xl tw-font-bold ">
          Timesheet summary
        </h4>
        <table className="timesheets__table">
          <thead>
            <tr>
              <th className="timesheets__summary-tableelem timesheets__table-header timesheets__summary-headerelem">
                RATE
              </th>
              <th className="timesheets__summary-tableelem timesheets__table-header timesheets__summary-headerelem">
                CHARGE
              </th>
              <th className="timesheets__summary-tableelem timesheets__table-header timesheets__summary-headerelem">
                {timesheet.temporaryVacancyTimeUnitCode === "H"
                  ? "HOURS"
                  : "DAYS"}
              </th>
            </tr>
          </thead>
          <tbody>
            {timesheet.rates.map((rateElem, i) => (
              <tr className="timesheets__row" key={rateElem.displayName + i}>
                <td className="timesheets__summary-tableelem">
                  {rateElem.displayName}
                </td>
                <td className="timesheets__summary-tableelem">
                  £{rateElem.invoice}
                </td>
                <td className="timesheets__summary-tableelem">
                  {timesheet.standardRateTotals[i] &&
                    Object.keys(timesheet.standardRateTotals[i]).length !==
                      0 && (
                      <span
                        className="timesheets__rates_inner"
                        key={`invqty${i}`}
                      >
                        <span className="timesheets__rates_inner-elem">
                          {timesheet.temporaryVacancyTimeUnitCode === "H"
                            ? parseHours(
                                timesheet.standardRateTotals[i].invoiceQty
                              )
                            : timesheet.standardRateTotals[i].invoiceQty}
                        </span>
                      </span>
                    )}
                </td>
              </tr>
            ))}
            <tr className="timesheets__summary-totalrow">
              <td className="timesheets__summary-totaltitle">Total</td>
              <td className="timesheets__summary-totalelem timesheets__summary-charge">
                £{totaledInvoices.toFixed(2)}
              </td>
              <td className="timesheets__summary-totalelem timesheets__summary-totallastelem">
                {timesheet.temporaryVacancyTimeUnitCode === "H"
                  ? parseHours(
                      timesheet.standardRateTotals.reduce(
                        (_acc, _totalElem) =>
                          _totalElem.invoiceQty
                            ? _acc + _totalElem.invoiceQty
                            : _acc,
                        0
                      )
                    )
                  : timesheet.standardRateTotals.reduce(
                      (_acc, _totalElem) =>
                        _totalElem.invoiceQty
                          ? _acc + _totalElem.invoiceQty
                          : _acc,
                      0
                    )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="timesheets__summary-buttons">
        <Link
          className="timesheets__summary-button"
          to={{
            pathname: `/timesheets/${timesheet.timesheetRef}`,
            state: {
              sortedTimesheetRefs: sortedRows.map(sr => sr.timesheetRef)
            }
          }}
        >
          <button className="btn btn-primary timesheets__summary-viewButton w-100">
            View timesheet
          </button>
        </Link>
        <button
          className="btn btn-primary timesheets__summary-button"
          onClick={closeHandler}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default Summary;
